import React, { useEffect } from "react";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useHospitalContext } from "../../context/HospitalContext";
import { useSelector } from "react-redux";
import { store } from "../../redux/store";
import * as loginActions from '../../redux/actions/loginActions';
import * as slotActions from '../../redux/actions/slotsActions';

import * as queueActions from '../../redux/actions/queueActions';

const HospitalSelection = () => {

  const { selectedHospital, setSelectedHospital } = useHospitalContext();
  const authReducer = useSelector((state) => state.authReducer);
  const hospitals = authReducer?.userAttributes?.hospitals || []

  const changeHospital = (e) => {
    const hospitalId = e.target.value;
    const hospital = hospitals.find(h => h.id === hospitalId);
    localStorage.setItem("hospitalId", hospital?.id);
  
    // clear old dashboard 
    store.dispatch(slotActions.resetSlotsAction());
    store.dispatch(queueActions.resetQueueAction());
  
    // update context
    setTimeout(() => {
      setSelectedHospital(hospital);
    }, 500); 
  
    store.dispatch(loginActions.changeHospitalRequestAction(hospitalId));
  };

  return (
    <FormControl >
      <Select
      value={selectedHospital?.id || ""}
        onChange={(e) => changeHospital(e)}
        renderValue={(hospitalId) => {
          const hospital = hospitals.find(h => h.id === hospitalId);
          return (
            <Box display="flex" alignItems="center">
              {hospital?.logo && (
                <img src={hospital.logo} alt="." style={{ width: 24, height: 24, marginRight: 9 }} />
              )}
              <Typography sx={{  fontWeight: '400', fontSize: '17px' }}>
                {hospital?.name}
              </Typography>
            </Box>
          );
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: "12px",
              mt: 2,
              padding: "8px",
              minWidth: '220px',
            }
          }
        }}
        sx={{
          borderRadius: "12px",
          background: "#F2F2F2",
          padding: "8px",
          height: '44px',
          minWidth: '220px',

          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
          }
        }}
      >
        {hospitals.map((item) => (
          <MenuItem key={item?.id} value={item.id} sx={{
            backgroundColor: "white",
            "&.Mui-selected": {
              backgroundColor: "#D3D3D3 !important",
            },

            "&.Mui-selected:hover": {
              backgroundColor: "#D3D3D3 !important",
            },
            "&:hover": {
              backgroundColor: "#f5f5f5"
            }
          }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              {item?.logo && <img src={item?.logo} alt="." style={{width: 24, height: 24 ,marginRight:9}} /> }

              <Typography sx={{
                fontWeight: '400',
                fontSize: '17px',
                color: item?.id !== selectedHospital?.id ? 'rgba(138, 138, 138, 1)' : 'rgba(18, 18, 18, 1)'
              }}>{item.name}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default HospitalSelection;
